// Constants
const ScrollMagic = require('ScrollMagic');

require('animation.gsap');
require('debug.addIndicators');
require('TweenMax');
require('TimelineLite');


const Home = {

    /**
     * Initialization
     */
    
    init() {
        //console.log('inited home');
        Home.inspiredTransition();
    },
    headerTransition: function() {
        var controller = new ScrollMagic.Controller();
        var timeline = new TimelineLite()
            .add(TweenMax.to("#header", 0.8, {className:"+=scrolled"}));
        var scene = new ScrollMagic.Scene({ duration: 200})
                .setTween(timeline)
                //.addIndicators()
                .addTo(controller);
        controller.addScene(scene);
    },
    sliderTransition: function() {
        var controller = new ScrollMagic.Controller();
        var timeline = new TimelineLite()
            .add(TweenMax.to("#wipe-copy-1", 0.3, { opacity: "1", paddingTop: "0px"}))
            .add(TweenMax.to("#wipe-1", 1, { height: "0%"}));
        var scene = new ScrollMagic.Scene({ triggerElement: "#wipe-trigger", duration: "50%", offset: 200})
                .setTween(timeline)
                //.addIndicators()
                .addTo(controller);
        controller.addScene(scene);
    },
    inspiredTransition: function() {
        var controller = new ScrollMagic.Controller();
        var timeline = new TimelineLite()
             .add(TweenMax.to("#get-inspired", 0.3, {className:"+=scrolled"}));
        var scene = new ScrollMagic.Scene({ triggerElement: "#get-inspired", duration: "75%"})
                .setTween(timeline)
                //.addIndicators()
                .addTo(controller);
        controller.addScene(scene);
    }
};

export default Home;




// WEBPACK FOOTER //
// ./src/js/components/home.js